<template>
    <div>
        <f7-block-title
            v-if="newExercises.length"
            style="margin: 40px 0 0 20px; line-height: 20px"
        >
            New for you
        </f7-block-title>
        <f7-list
            media-list
            style="margin-bottom: 0px"
        >
            <sequential-entrance from-bottom>
                <template v-for="(unit, index) in newExercises">

                    <unit-card
                        v-show="index < 2"
                        :unit="unitsIndex[unit.id]"
                        :key="`ask-reco-units-${index}`"
                        :home="true"
                        :in-card="true"
                        :index="index"
                        :pack="newExercises"
                    />
                </template>
            </sequential-entrance>
        </f7-list>
        <p
            v-if="newExercises && newExercises.length > 2"
            class="moreLinks"
        >
            <a
                href="/explore/play/new"
                class="moreLink"
            >View all &mdash;</a>
        </p>
        <br style="clear: both; line-height: 0">

        <!-- <sequential-entrance from-right> -->
        <template v-for="(topic, i) in allTopics">
            <div
                v-show="topic.type === 'play'"
                :key="`topic-t4-${i}`"
                class="topic"
            >
                <f7-block-title style="margin: 40px 0 0 20px; line-height: 20px">
                    {{ topic.name }}
                </f7-block-title>

                <f7-swiper
                    :navigation="!isPgap"
                    :params="{slidesOffsetBefore: 12, speed:500, slidesPerView: 'auto', spaceBetween: 6, noSwiping: true}"
                >
                    <template v-for="(course, j) in topic.courses">
                        <course-card
                            :course="course"
                            :topic="topic"
                            :link="`/courses/${course.id}`"
                            :key="`t-${i}-c-${j}`"
                            :locked="false"
                            :disabled="topic.comingSoon"
                            :style="topic.comingSoon ? 'opacity: 0.5' : ''"
                        />
                    </template>
                </f7-swiper>

                <div
                    v-if="topic.comingSoon"
                    :key="`t-${i}-c-${j}-soon`"
                    class="comingSoon"
                >Coming soon...</div>

            </div>

        </template>
        <!-- </sequential-entrance> -->
    </div>
</template>

<script>
import UnitCard from '../../components/unitCard.vue';
import CourseCard from '../../components/courseCard.vue';

import utils from '../../js/utils';

export default {
    store: ['api', 'newExercises', 'topics', 'topicsIndex', 'fullDataIndex', 'courses', 'coursesIndex', 'myTraits', 'unitsIndex', 'units'],
    components: {
        CourseCard,
        UnitCard
    },
    data () {
        return {
            customTopics: []
        };
    },
    computed: {
        isPgap: function () {
            return pgap;
        },
        allTopics: function () {
            let goodOnes = [];
            for (let i = 0; i < this.topics.length; i++) {
                const topic = this.topics[i];
                if (topic.type === 'play') {
                    goodOnes.push(topic);
                    goodOnes[goodOnes.length - 1].courses = this.fullDataIndex[topic.id].courses;
                }
            }
            return this.customTopics.concat(goodOnes);
        }
    },
    mounted: function () {
        this.createNewUnits();
    },
    methods: {
        lessThan30DayOld: function (unit) {
            var fortnightAway = new Date(Date.now() - (12096e5 * 2));
            if ((new Date(unit.createdAt).getTime() - fortnightAway.getTime()) > 0) {
                return true;
            }
            return false;
        },
        createNewUnits: function () {
            this.newExercises = [];
            let units = this.units.slice().sort((a, b) => {
                var dateA = new Date(a.createdAt);
                var dateB = new Date(b.createdAt);
                return dateA - dateB;
            }).reverse();
            for (let i = 0; i < units.length; i++) {
                const u = units[i];
                if (!u.completed &&
                    !u.started &&
                    u.type === 'game' &&
                    this.lessThan30DayOld(u) &&
                    utils.checkTraits(this.myTraits, u)) {
                    this.newExercises.push(u);
                }
            }
        },
        goToInPopup: function (url) {
            f7.views['popup'].router.navigate(url, {
                animate: false,
                clearPreviousHistory: true
            });
            if (!pgap) window.history.pushState(null, "", '/web' + url);
            setTimeout(() => {
                f7.popup.get('#popup').open();
            }, 250);
            // f7.statusbar.setTextColor('white');
        },
        goTo: function (url) {
            f7.views['main'].router.navigate(url);
        }
    }
};
</script>
<style lang="less" scoped>
@import '../../css/colors.less';
.moreLinks {
    padding: 0;
    text-align: right;
    margin: -20px 16px 0;
    text-transform: uppercase;
    font-family: AndesMedium;
    letter-spacing: 1px;
    font-weight: bold;
    font-size: 12px;
    color: #ff6f61;
}
.moreLink {
    font-size: 15px;
    color: @coral;
    font-family: AndesMedium;
    text-transform: uppercase;
    line-height: 44px;
    float: right;
    z-index: 100;
    position: relative;
}
</style>
